import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'monthNumberToName',
  standalone: true
})
export class MonthNumberToNamePipe implements PipeTransform {

  public transform(monthNumber: number, format: 'MMMM' | 'MMM' | 'MM' | 'M' = 'MMM'): string {
    return dayjs().set('month', monthNumber).format(format);
  }
}
